import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-154">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-155">
        <img src="https://cdn.magicpatterns.com/uploads/fcKF7LPYXApRrE1fBXihTe/Banner_Mati_Sales_Page_2.png" alt="Pareja mirando el atardecer en la playa" className="w-full h-full object-cover object-[center_70%]" data-id="element-156" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-dark/70 via-charcoal-dark/50 to-charcoal-dark z-10" data-id="element-157"></div>
      </div>

      <div className="relative z-20 max-w-5xl mx-auto px-6 text-center" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-159">
          <h1 className="text-[1.6rem] leading-[1.3] md:text-5xl lg:text-7xl font-heading font-bold text-offwhite md:leading-tight mb-6 md:mb-8" data-id="element-160">
            RESET es el sistema que ordena{' '}
            <span className="text-sand" data-id="element-161">cuerpo y mente</span> para que dejes de
            sentirte desalineado y vuelvas a tener{' '}
            <span className="text-sand" data-id="element-162">control real</span> en tu día.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-163">
          <p className="text-lg md:text-2xl text-offwhite-dim font-light mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-164">
            En 7 días recuperás energía estable, claridad mental y un sistema
            diario sostenible. Sin motivación forzada. Sin perfección.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-165">
          <Button href="https://wa.link/we351n" size="lg" withArrow className="shadow-2xl shadow-sand/20" data-id="element-166">
            Escribí RESET → $47 esta semana (quedan 5 cupos)
          </Button>
          <p className="mt-6 text-sm text-offwhite-dim/60 font-medium tracking-wide uppercase" data-id="element-167">
            Acompañamiento 1 a 1 • Cupos Limitados
          </p>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-168">
        <a href="#lead" className="text-offwhite-dim/50 hover:text-sand transition-colors" aria-label="Scroll down" data-id="element-169">
          <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-sand to-transparent mx-auto" data-id="element-170"></div>
        </a>
      </motion.div>
    </section>;
}